import { render, staticRenderFns } from "./BetInfo.vue?vue&type=template&id=49a6b072&scoped=true&"
import script from "./BetInfo.vue?vue&type=script&lang=js&"
export * from "./BetInfo.vue?vue&type=script&lang=js&"
import style0 from "./BetInfo.vue?vue&type=style&index=0&id=49a6b072&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a6b072",
  null
  
)

export default component.exports